module.exports = __webpack_public_path__ + "static/media/bg-1.8f621d1c.jpg";